var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeChannelsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22512,
    stopColor: "#ff5663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96004a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.1972,33.15593h-32.39435c-3.42011,0-6.19265,2.77255-6.19265,6.1926v21.30292c0,3.42011,2.77255,6.1926,6.19265,6.1926h32.39435c3.42011,0,6.1926-2.7725,6.1926-6.1926v-21.30292c0-3.42006-2.7725-6.1926-6.1926-6.1926ZM44.44131,58.99767v-17.99529l15.58439,8.99762-15.58439,8.99767Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeChannelsScraper);
export default __webpack_public_path__ + "static/media/youtube-channels-scraper.4c51556976b4d054c52c8f28842b145d.svg";
export { ForwardRef as ReactComponent };